import React from 'react'

function BalanceFundFuture() {
  return (
    <div>BalanceFundFuture</div>
  )
}

export default BalanceFundFuture